module.exports = __webpack_public_path__ + "img/check_s3dweb.933eedc3.png";